import React from 'react';
import ErrorOutline from '@material-ui/icons/Error';
import RotateLeft from '@material-ui/icons/RotateLeft';
import CheckCircle from '@material-ui/icons/CheckCircle';
import InfoOutline from '@material-ui/icons/Info';
import Warning from '@material-ui/icons/Warning';

export const TOAST_TYPES = {
    SUCCESS: 0,
    WARNING: 1,
    INFO: 2,
    ERROR: 3,
    LOADING: 4
};

export const TOAST_PROPERTIES = {
    0: { icon: <CheckCircle className="snack-icon green-fill" />, classes: {} },
    1: { icon: <Warning className="snack-icon yellow-fill" />, classes: {} },
    2: { icon: <InfoOutline className="snack-icon blue-fill" />, classes: {} },
    3: { icon: <ErrorOutline className="snack-icon red-fill" />, classes: {} },
    4: { icon: <RotateLeft className="snack-icon" />, classes: {} }
};



// WEBPACK FOOTER //
// ./src/state/reducer/clipboard/toastTypes.js